import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const TroubeshootingOrderDetails = () =>
  import('@/pages/troubleshooting/orderdetails/OrderDetails.vue');
const PpTokenUsage = () => import('@/pages/troubleshooting/ppTokenUsage/PpTokenUserage.vue');
const MissingVoiceApiCalls = () =>
  import('@/pages/troubleshooting/missingVoiceApiCalls/MissingVoiceApiCalls.vue');
const AccountDetails = () => import('@/pages/troubleshooting/accountDetails/AccountDetails.vue');
const AccountActivityTimeline = () =>
  import('@/pages/troubleshooting/account-activity-timeline/AccountActivityTimeline.vue');
const PriceUpdates = () =>
  import('@/pages/troubleshooting/pois-and-shops/price-updates/PriceUpdates.vue');
const StationStatus = () =>
  import('@/pages/troubleshooting/pois-and-shops/station-status/StationStatus.vue');
const OrderSearchByPoiWrapper = () =>
  import('@/pages/troubleshooting/order-search/OrderSearchByPoiWrapper.vue');
const ShopDetails = () =>
  import('@/pages/troubleshooting/pois-and-shops/shop-details/ShopDetails.vue');
const PlaceSearch = () =>
  import('@/pages/troubleshooting/pois-and-shops/place-search/PlaceSearch.vue');

export const troubleshootingRoutes: AppRouteRecordRaw[] = [
  {
    path: '/troubleshooting',
    component: Body,
    meta: {
      requiresAuth: true,
      breadcrumb: 'Troubleshooting',
    },
    children: [
      {
        path: 'order-details',
        name: 'order-details',
        component: TroubeshootingOrderDetails,
        meta: {
          title: ' Troubleshooting Order Details | ryd Portal',
          breadcrumb: 'Order Details',
        },
      },
      {
        path: 'shop-details',
        redirect: '/troubleshooting/pois-and-shops/shop-details',
      },
      {
        path: 'pois-shops/search',
        redirect: '/troubleshooting/pois-and-shops/search',
      },
      {
        path: 'pois-and-shops/search',
        name: 'place-search',
        component: PlaceSearch,
        meta: {
          title: ' Search POIs and Shops | ryd Portal',
          breadcrumb: 'Search POIs / Shops',
        },
      },
      {
        path: 'pois-shops/shop-details',
        redirect: '/troubleshooting/pois-and-shops/shop-details',
      },
      {
        path: 'pois-and-shops/shop-details',
        name: 'shop-details',
        component: ShopDetails,
        meta: {
          title: ' Shop Details | ryd Portal',
          breadcrumb: 'Shop Details',
        },
      },
      {
        path: 'token-usage',
        name: 'token-usage',
        component: PpTokenUsage,
        meta: {
          title: ' Troubleshooting Token Usage | ryd Portal',
          requiredUserGroup: ['ryd', 'parkopedia'],
          breadcrumb: 'Token Usage',
        },
      },
      {
        path: 'missing-invoice-api-calls',
        name: 'missing-invoice-api-calls',
        component: MissingVoiceApiCalls,
        meta: {
          title: ' Troubleshooting Missing Invoice API Calls | ryd Portal',
          requiredUserGroup: ['ryd', 'parkopedia'],
          breadcrumb: 'Missing Successful invoice API Call',
        },
      },
      {
        path: 'account-activities',
        name: 'account-activities',
        component: AccountDetails,
        meta: {
          title: ' Troubleshooting Account Activities | ryd Portal',
          breadcrumb: 'Account Activities',
        },
      },
      {
        path: 'account-activity-timeline',
        name: 'account-activity-timeline',
        component: AccountActivityTimeline,
        meta: {
          title: ' Account Activity Timeline | ryd Portal',
          requiredUserGroup: ['ryd'],
          breadcrumb: 'Account Activity Timeline',
        },
      },
      {
        path: 'price-updates',
        redirect: '/troubleshooting/pois-and-shops/price-updates',
      },
      {
        path: 'pois-shops/price-updates',
        redirect: '/troubleshooting/pois-and-shops/price-updates',
      },
      {
        path: 'pois-and-shops/price-updates',
        name: 'price-updates',
        component: PriceUpdates,
        meta: {
          title: ' Price Updates of POIs | ryd Portal',
          requiredUserGroup: ['ryd'],
          breadcrumb: 'Station Price Updates',
        },
      },
      {
        path: 'pois-shops/station-status',
        redirect: '/troubleshooting/pois-and-shops/station-status',
      },
      {
        path: 'pois-and-shops/station-status',
        name: 'station-status',
        component: StationStatus,
        meta: {
          title: ' Station Online / Offline Status | ryd Portal',
          requiredPartnerTypes: ['RYD_INTERNAL', 'API_PARTNER'],
          breadcrumb: 'Station Online / Offline Status',
        },
      },
      {
        path: 'order-data-by-location', // old path from ryd partner portal
        name: 'order-data-by-location',
        component: OrderSearchByPoiWrapper,
        meta: {
          title: ' Order Data By Location | ryd Portal',
          breadcrumb: 'Order Search By Location',
        },
      },
    ],
  },
];
